export const CARD_PAYMENT_SUCCESS_TITLE = 'Отлично!';

export const CARD_PAYMENT_SUCCESS_DESCRIPTION =
	'Всё получилось. Теперь вы можете получать оплату по номеру карты';
